module.exports = __webpack_public_path__ + "media/images/envelope-5e385b42a4b35431096304c97e676c09.svg";